// basic text truncate with given truncateOptions.
// Usage: truncateText('text to truncate', { numberOfLines: 1 })
// Visit https://github.com/jackyr/react-multi-clamp#readme for more information about other options.

import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import styled from 'styled-components'
import isServerSide from '../../modules/is-server-side'

const MultiClamp = loadable(() => import(/* webpackChunkName: "react-multi-clamp" */ 'react-multi-clamp'), {
  ssr: false,
})

const SSRClamp = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => (props.clamp ? props.clamp : '2')};
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const TruncateText = ({ text, truncateOptions }) => {
  if (!isServerSide()) {
    return (
      <MultiClamp
        fallback={text}
        clamp={truncateOptions && truncateOptions.numberOfLines}
        ellipsis={truncateOptions && truncateOptions.ellipsis}
      >
        {text}
      </MultiClamp>
    )
  } else {
    return (
      <SSRClamp
        clamp={truncateOptions && truncateOptions.numberOfLines}
        ellipsis={truncateOptions && truncateOptions.ellipsis}
      >
        {text}
      </SSRClamp>
    )
  }
}

TruncateText.propTypes = {
  text: PropTypes.string,
  truncateOptions: PropTypes.shape({
    numberOfLines: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]),
    ellipsis: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  }),
}

export default TruncateText
